import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询家政服务费用配置关系
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServConfig(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/queryHousekeepingServConfig',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政费用类型
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingFeeType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeType/queryHousekeepingFeeType',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政类型
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政费用配置
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingFeeConfig(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingFeeConfig/queryHousekeepingFeeConfig',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存家政服务费用
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveHousekeepingServFee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServFee/saveHousekeepingServFee',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除家政服务费用
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteHousekeepingServFee(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServFee/deleteHousekeepingServFee',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}